export default __webpack_public_path__ + "static/media/Group 40.7a8016dd.svg";